/**
 * 조선총독부서임급사령 목록 데이터
 */
export const GwanboData = [
    {
        "book_id": 6683,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4575號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 2,
        "publish_date": "昭和17年 05月 02日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6684,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4576號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 4,
        "publish_date": "昭和17年 05月 04日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6685,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4579號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 7,
        "publish_date": "昭和17年 05月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6686,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4582號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 11,
        "publish_date": "昭和17年 05月 11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6687,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4583號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 12,
        "publish_date": "昭和17年 05月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6688,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4584號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 13,
        "publish_date": "昭和17年 05月 13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6689,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4586號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 15,
        "publish_date": "昭和17年 05月 15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6690,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4588號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 18,
        "publish_date": "昭和17年 05月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6691,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4590號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 20,
        "publish_date": "昭和17年 05月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6692,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4592號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 22,
        "publish_date": "昭和17年 05月 22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6693,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4593號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 23,
        "publish_date": "昭和17年 05月 23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6694,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4596號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 27,
        "publish_date": "昭和17年 05月 27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6695,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4597號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 5,
        "publish_day": 28,
        "publish_date": "昭和17年 05月 28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6696,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4753號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 3,
        "publish_date": "昭和17年 12月 03日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6697,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4759號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 10,
        "publish_date": "昭和17年 12月 10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6698,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4766號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 18,
        "publish_date": "昭和17年 12月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6699,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "號外",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 12,
        "publish_day": 31,
        "publish_date": "昭和17年 12月 31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6700,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4778號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 8,
        "publish_date": "昭和18年 01月 08日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6701,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4780號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 11,
        "publish_date": "昭和18年 01月 11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6702,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4782號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 13,
        "publish_date": "昭和18年 01月 13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6703,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4796號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 1,
        "publish_day": 29,
        "publish_date": "昭和18年 01月 29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6704,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4480號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 1,
        "publish_day": 6,
        "publish_date": "昭和17年 01月 06日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6705,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4481號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 1,
        "publish_day": 7,
        "publish_date": "昭和17年 01月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6706,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4483號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 1,
        "publish_day": 9,
        "publish_date": "昭和17年 01月 09日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6707,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4490號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 1,
        "publish_day": 17,
        "publish_date": "昭和17年 01月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6708,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4492號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 1,
        "publish_day": 20,
        "publish_date": "昭和17年 01月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6709,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4497號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 1,
        "publish_day": 26,
        "publish_date": "昭和17年 01月 26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6710,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4499號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 1,
        "publish_day": 28,
        "publish_date": "昭和17年 01月 28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6711,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4551號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 1,
        "publish_date": "昭和17年 04月 01日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6712,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4552號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 2,
        "publish_date": "昭和17年 04月 02日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6713,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4553號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 4,
        "publish_date": "昭和17年 04月 04日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6714,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4554號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 6,
        "publish_date": "昭和17年 04月 06日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6715,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4555號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 7,
        "publish_date": "昭和17年 04月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6716,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4556號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 8,
        "publish_date": "昭和17年 04月 08日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6717,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4558號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 10,
        "publish_date": "昭和17年 04月 10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6718,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4559號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 11,
        "publish_date": "昭和17年 04月 11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6719,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4560號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 13,
        "publish_date": "昭和17年 04月 13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6720,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4563號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 16,
        "publish_date": "昭和17年 04月 16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6721,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4564號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 17,
        "publish_date": "昭和17年 04月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6722,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4565號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 18,
        "publish_date": "昭和17年 04月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6723,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4567號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 21,
        "publish_date": "昭和17年 04月 21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6724,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4569號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 23,
        "publish_date": "昭和17年 04月 23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6725,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4571號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 27,
        "publish_date": "昭和17年 04月 27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6726,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4572號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 28,
        "publish_date": "昭和17年 04月 28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6727,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4573號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和17年 04月 30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6728,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4924號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 2,
        "publish_date": "昭和18年 07月 02日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6729,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4924號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 2,
        "publish_date": "昭和18年 07月 01日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6730,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4925號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 3,
        "publish_date": "昭和18年 07月 03日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6731,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4926號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 5,
        "publish_date": "昭和18年 07月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6732,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4928號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "昭和18年 07月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6733,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4932號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 12,
        "publish_date": "昭和18年 07月 10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6734,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4932號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 7,
        "publish_day": 12,
        "publish_date": "昭和18年 07月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6735,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4656號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 5,
        "publish_date": "昭和17年 08月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6736,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4664號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 14,
        "publish_date": "昭和17年 08月 14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6737,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4667號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 18,
        "publish_date": "昭和17年 08月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6738,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4668號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 19,
        "publish_date": "昭和17年 08月 19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6739,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4669號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 20,
        "publish_date": "昭和17年 08月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6740,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4673號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 25,
        "publish_date": "昭和17年 08月 25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6741,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4676號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 28,
        "publish_date": "昭和17年 08月 28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6742,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4677號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 29,
        "publish_date": "昭和17年 08月 29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6743,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4678號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 8,
        "publish_day": 31,
        "publish_date": "昭和17年 08月 31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6744,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4821號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 1,
        "publish_date": "昭和18年 03月 01日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6745,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4823號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 3,
        "publish_date": "昭和18年 03月 03日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6746,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4825號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 5,
        "publish_date": "昭和18年 03月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6747,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4826號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 6,
        "publish_date": "昭和18年 03月 06日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6748,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4832號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 13,
        "publish_date": "昭和18年 03月 13日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6749,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4835號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 17,
        "publish_date": "昭和18年 03月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6750,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4835號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 17,
        "publish_date": "昭和18年 03月 15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6751,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4836號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 18,
        "publish_date": "昭和18年 03月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6752,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4843號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 26,
        "publish_date": "昭和18年 03月 26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6753,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4844號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 27,
        "publish_date": "昭和18年 03月 27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6754,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4845號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 29,
        "publish_date": "昭和18年 03月 29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6755,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4847號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 3,
        "publish_day": 31,
        "publish_date": "昭和18年 03月 31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6756,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4735號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 11,
        "publish_date": "昭和17年 11月 11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6757,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4742號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 19,
        "publish_date": "昭和17年 11月 19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6758,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4743號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 20,
        "publish_date": "昭和17年 11月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6759,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4749號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 11,
        "publish_day": 28,
        "publish_date": "昭和17年 11月 28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6760,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4684號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 7,
        "publish_date": "昭和17年 09月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6761,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4685號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 8,
        "publish_date": "昭和17年 09月 08日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6762,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4686號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 9,
        "publish_date": "昭和17年 09月 09日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6763,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4690號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 14,
        "publish_date": "昭和17年 09月 14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6764,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4691號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 15,
        "publish_date": "昭和17年 09月 15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6765,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4694號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 18,
        "publish_date": "昭和17年 09月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6766,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4696號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 21,
        "publish_date": "昭和17年 09月 21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6767,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4697號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 22,
        "publish_date": "昭和17年 09月 22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6768,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4698號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 23,
        "publish_date": "昭和17年 09月 23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6769,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4702號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 29,
        "publish_date": "昭和17年 09月 29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6770,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4703號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 9,
        "publish_day": 30,
        "publish_date": "昭和17年 09月 30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6771,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4631號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 7,
        "publish_date": "昭和17年 07月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6772,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4632號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 8,
        "publish_date": "昭和17年 07月 08日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6773,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4633號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 9,
        "publish_date": "昭和17年 07月 09日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6774,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4634號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 10,
        "publish_date": "昭和17年 07月 10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6775,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4638號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 15,
        "publish_date": "昭和17年 07月 15日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6776,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4640號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 17,
        "publish_date": "昭和17年 07月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6777,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4643號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 21,
        "publish_date": "昭和17年 07月 21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6778,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4644號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 22,
        "publish_date": "昭和17年 07月 22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6779,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4650號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 29,
        "publish_date": "昭和17年 07月 29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6780,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4652號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 7,
        "publish_day": 31,
        "publish_date": "昭和17年 07月 31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6781,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4849號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 2,
        "publish_date": "昭和18年 04月 02日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6782,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4850號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 5,
        "publish_date": "昭和18年 04月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6783,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4852號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 7,
        "publish_date": "昭和18年 04月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6784,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4853號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 8,
        "publish_date": "昭和18年 04月 08日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6785,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4853號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 8,
        "publish_date": "昭和18年 04月 06日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6786,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4854號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 9,
        "publish_date": "昭和18年 04月 09日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6787,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4855號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 10,
        "publish_date": "昭和18年 04月 10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6788,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4856號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 12,
        "publish_date": "昭和18年 04月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6789,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4858號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 14,
        "publish_date": "昭和18年 04月 14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6790,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4861號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 17,
        "publish_date": "昭和18年 04月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6791,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4864號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 21,
        "publish_date": "昭和18年 04月 21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6792,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4865號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 22,
        "publish_date": "昭和18年 04月 22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6793,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4866號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 23,
        "publish_date": "昭和18年 04月 22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6794,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4866號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 23,
        "publish_date": "昭和18年 04月 23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6795,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4870號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 4,
        "publish_day": 30,
        "publish_date": "昭和18年 04月 30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6796,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4506號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 5,
        "publish_date": "昭和17年 02月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6797,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4508號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 7,
        "publish_date": "昭和17年 02月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6798,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4511號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 12,
        "publish_date": "昭和17年 02月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6799,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4516號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 18,
        "publish_date": "昭和17年 02月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6800,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4518號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 20,
        "publish_date": "昭和17年 02月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6801,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4523號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 26,
        "publish_date": "昭和17年 02月 26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6802,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4524號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 2,
        "publish_day": 27,
        "publish_date": "昭和17年 02月 27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6803,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4798號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 1,
        "publish_date": "昭和18年 02月 01日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6804,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4801號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 4,
        "publish_date": "昭和18年 02月 04日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6805,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4802號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 5,
        "publish_date": "昭和18年 02月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6806,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4810號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 16,
        "publish_date": "昭和18年 02月 16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6807,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4813號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 19,
        "publish_date": "昭和18年 02月 19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6808,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4817號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 24,
        "publish_date": "昭和18年 02月 24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6809,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4819號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 2,
        "publish_day": 26,
        "publish_date": "昭和18年 02月 26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6810,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4871號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 1,
        "publish_date": "昭和18年 05月 01日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6811,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4873號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 4,
        "publish_date": "昭和18年 05月 04日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6812,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4874號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 5,
        "publish_date": "昭和18年 05月 03日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6813,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4874號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 5,
        "publish_date": "昭和18年 05月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6814,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4875號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 6,
        "publish_date": "昭和18年 05月 06日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6815,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4880號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 12,
        "publish_date": "昭和18年 05月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6816,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4882號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 14,
        "publish_date": "昭和18年 05月 14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6817,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4884號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 17,
        "publish_date": "昭和18年 05月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6818,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4886號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 19,
        "publish_date": "昭和18年 05月 19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6819,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4887號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 20,
        "publish_date": "昭和18年 05月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6820,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4888號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 21,
        "publish_date": "昭和18年 05月 21日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6821,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4889號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 22,
        "publish_date": "昭和18年 05月 22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6822,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4892號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 26,
        "publish_date": "昭和18年 05月 26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6823,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4893號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 27,
        "publish_date": "昭和18年 05月 27日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6824,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4895號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 5,
        "publish_day": 29,
        "publish_date": "昭和18年 05月 29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6825,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4528號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 4,
        "publish_date": "昭和17年 03月 04日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6826,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4529號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 5,
        "publish_date": "昭和17年 03月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6827,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4532號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 9,
        "publish_date": "昭和17年 03月 09日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6828,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4539號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 17,
        "publish_date": "昭和17年 03月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6829,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4541號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 19,
        "publish_date": "昭和17年 03月 19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6830,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4542號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 20,
        "publish_date": "昭和17年 03月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6831,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4548號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 28,
        "publish_date": "昭和17年 03月 28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6832,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4550號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 3,
        "publish_day": 31,
        "publish_date": "昭和17年 03月 31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6833,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "號外",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 12,
        "publish_day": 31,
        "publish_date": "昭和18年 12月 31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6834,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4899號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 3,
        "publish_date": "昭和18年 06月 03日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6835,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4900號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 4,
        "publish_date": "昭和18年 06月 04日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6836,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4903號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 8,
        "publish_date": "昭和18年 06月 08日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6837,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4904號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 9,
        "publish_date": "昭和18年 06月 09日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6838,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4905號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 10,
        "publish_date": "昭和18年 06月 10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6839,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4907號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 12,
        "publish_date": "昭和18年 06月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6840,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4907號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 12,
        "publish_date": "昭和18年 06月 11日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6841,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4908號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 14,
        "publish_date": "昭和18年 06月 14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6842,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4910號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 16,
        "publish_date": "昭和18年 06月 16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6843,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4911號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 17,
        "publish_date": "昭和18年 06月 17日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6844,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4912號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 18,
        "publish_date": "昭和18年 06月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6845,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4915號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 22,
        "publish_date": "昭和18年 06月 22日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6846,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4917號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 24,
        "publish_date": "昭和18年 06月 24日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6847,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4918號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 25,
        "publish_date": "昭和18年 06月 25日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6848,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4919號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 26,
        "publish_date": "昭和18年 06月 26日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6849,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4922號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1943,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "昭和18年 06月 30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6850,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4706號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 5,
        "publish_date": "昭和17年 10月 05日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6851,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4708號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 7,
        "publish_date": "昭和17年 10月 07日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6852,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4712號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 12,
        "publish_date": "昭和17年 10月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6853,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4714號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 14,
        "publish_date": "昭和17年 10月 14日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6854,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4717號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 20,
        "publish_date": "昭和17年 10月 20日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6855,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4724號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 28,
        "publish_date": "昭和17年 10月 28日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6856,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4726號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 30,
        "publish_date": "昭和17年 10月 30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6857,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4727號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 10,
        "publish_day": 31,
        "publish_date": "昭和17年 10月 31日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6858,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4600號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 1,
        "publish_date": "昭和17年 06月 01日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6859,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4601號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 2,
        "publish_date": "昭和17年 06月 02日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6860,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4602號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 3,
        "publish_date": "昭和17年 06月 03日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6861,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4603號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 4,
        "publish_date": "昭和17年 06月 04日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6862,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4606號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 8,
        "publish_date": "昭和17年 06月 08日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6863,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4607號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 9,
        "publish_date": "昭和17年 06月 09日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6864,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4608號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 10,
        "publish_date": "昭和17年 06月 10日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6865,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4610號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 12,
        "publish_date": "昭和17年 06月 12日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6866,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4613號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 16,
        "publish_date": "昭和17年 06月 16日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6867,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4615號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 18,
        "publish_date": "昭和17年 06月 18日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6868,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4615號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 19,
        "publish_date": "昭和17年 06月 19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6869,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4616號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 19,
        "publish_date": "昭和17年 06月 19日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6870,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4619號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 23,
        "publish_date": "昭和17年 06月 23日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6871,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4624號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 29,
        "publish_date": "昭和17年 06月 29日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    },
    {
        "book_id": 6872,
        "book_type": null,
        "book_category": "gwanbo",
        "book_title": "朝鮮總督府官報",
        "book_title_ko": "조선총독부관보",
        "numeration": "第4625號",
        "authors": null,
        "authors_ko": null,
        "publish_info": null,
        "publish_year": 1942,
        "publish_month": 6,
        "publish_day": 30,
        "publish_date": "昭和17年 06月 30日",
        "publisher": null,
        "publisher_ko": null,
        "library": null,
        "url": null,
        "note": null,
        "search_tag": null,
        "usernote": null
    }

];